import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { EMPTY, Observable } from 'rxjs';
import { Cookie } from 'ng2-cookies';
import { environment } from 'environments/environment';
import { AuthenticationService } from 'app/modules/session/services/authentication.service';

export class ApiAuthInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!req.headers.has('Authorization') && Cookie.get('auth_token')) {
      const updatedHeaders = req.headers.set('Authorization', 'Bearer ' + Cookie.get('auth_token'));
      req = req.clone({ headers: updatedHeaders });
      return next.handle(req);
    } else {
      // Redirect to login page if no auth_token exists.
      new AuthenticationService().redirectToAuthenticate();
      return EMPTY;
    }
  }
}
